// MUI Chip color variants for role badges
export const roleColors: Record<string, 'error' | 'secondary' | 'primary' | 'default'> = {
  admin: 'error',
  instructor: 'secondary',
  student: 'primary',
};

// Hex colors for role avatars and indicators
export const roleAvatarColors: Record<string, string> = {
  admin: '#e94560',
  instructor: '#3b82f6',
  student: '#22c55e',
};
